// extracted by mini-css-extract-plugin
export default {"body":"Listings_body__Fjthr","cards":"Listings_cards__F2nPP","card":"Listings_card__yRqBN"};